import classNames from "classnames"
import { Tooltip } from "primereact/tooltip"
import { useEffect, useState } from "react"
import "./styles.scss"

const SwitchButton = ({
  color,
  text,
  Icon,
  tooltip,
  id,
  handleOnSelect,
  btnSelected,
  className,
}: $TSMigrationFixMe) => {
  const switchClassnameID = `btn-switch-${id}`

  return (
    <>
      <button
        onClick={() => handleOnSelect({ id, text })}
        key={id}
        type='button'
        className={classNames([
          "btn-switch",
          switchClassnameID,
          `btn-switch--${color}`,
          {
            active: btnSelected === id,
          },
          className,
        ])}
      >
        {Icon && <Icon style={{ marginRight: text ? "5px" : "0px" }} />}

        {text}
      </button>

      {tooltip && (
        <Tooltip
          target={`.${switchClassnameID}`}
          content={tooltip}
        />
      )}
    </>
  )
}

const SwitchButtons = ({
  color = "primary",
  className,
  btns = [],
  onSelect,
  selectedButtonID,
  loadingData = false,
}: $TSMigrationFixMe) => {
  const [btnSelected, setBtnSelected] = useState(
    selectedButtonID || btns?.[0]?.id
  )

  useEffect(() => {
    if (selectedButtonID || selectedButtonID === 0) {
      setBtnSelected(selectedButtonID)
    }
  }, [selectedButtonID])

  const handleOnSelect = ({ id, text }: $TSMigrationFixMe) => {
    if (!loadingData) {
      setBtnSelected(id)
      onSelect({ id, text })
    }
  }

  return (
    <div className={`switch-btns-wrap ${className ?? ""} ml-auto`}>
      {/* @ts-expect-error TS(7031): Binding element 'Icon' implicitly has an 'any' typ... */}
      {btns.map(({ text = "", Icon, tooltip, id }) => (
        <SwitchButton
          key={`switch-button-${id}`}
          id={id}
          color={color}
          text={text}
          Icon={Icon}
          tooltip={tooltip}
          btnSelected={btnSelected}
          handleOnSelect={handleOnSelect}
          className='flex-fill'
        />
      ))}
    </div>
  )
}

export default SwitchButtons
